import initialState from './app.state.jsx';
import { fromJS } from 'immutable';
import { isEmptyValue, createReducerSwitch } from '../common/utils.jsx';
import setInitialDataReducer from './loader/reducer.jsx';
import { APP_INIT_DATA_RECEIVE } from './loader/actions.jsx';
import componentsReducer, { setFieldValueReducer, resetFieldValueReducer, completeQuestionnaireReducer } from './form.components/components.reducer.jsx';
import personsArrayReducer, { PERSONS_ARRAY_ACTIONS } from './form.components/persons.array/reducer.jsx';
import FCHReducer, { FCH_ACTIONS_LIST } from './form.components/family.cancer.history/reducer.jsx';
import {AnalyticsService} from "../fht/analytics";

export const SET_FIELD_VALUE = 'app/fields/SET_FIELD_VALUE';
export const RESET_FIELD_VALUE = 'app/fields/RESET_FIELD_VALUE';
export const COMPLETE_QUESTIONNAIRE = 'app/fields/COMPLETE_QUESTIONNAIRE';
export function setFieldValue(name, value, root) {
    if (isEmptyValue(name) || 'string' !== typeof name) {
        throw new TypeError('Action creator setFieldValue(name, value[, root]): name is invalid');
    }
    return {
        type: SET_FIELD_VALUE,
        root, name, value
    };
}

export function resetFieldValue(name, root) {
    if (isEmptyValue(name) || 'string' !== typeof name) {
        throw new TypeError('Action creator setFieldValue(name, value[, root]): name is invalid');
    }
    return {
        type: RESET_FIELD_VALUE,
        root, name
    };
}

export function completeQuestionnaire(lastPageIndex) {
  AnalyticsService.logEvent({type: 'Questionnaire Completed'});
    return {
        type: COMPLETE_QUESTIONNAIRE,
        lastPageIndex
    };
}

export function fieldsReducer(state = initialState.get('fields'), action = null) {
    return createReducerSwitch(state)
    .on(APP_INIT_DATA_RECEIVE, setInitialDataReducer)
    .on(SET_FIELD_VALUE, setFieldValueReducer)
    .on(RESET_FIELD_VALUE, resetFieldValueReducer)
    .on(PERSONS_ARRAY_ACTIONS, personsArrayReducer)
    .on(COMPLETE_QUESTIONNAIRE, completeQuestionnaireReducer)
    .reduce(action);
}

export const SET_ACTIVE_PAGE = 'app/pages/SET_ACTIVE_PAGE';
export const SET_LAST_PAGE = 'app/pages/SET_LAST_PAGE';
export const INIT_PAGES = 'app/pages/INIT_PAGES';
export const INIT_NAVIGATION_PAGES = 'app/pages/INIT_NAVIGATION_PAGES';
export function setActivePage(currentPageIndex) {
    return {
        type: SET_ACTIVE_PAGE,
        currentPageIndex
    };
}

export function setLastPage(lastPageIndex) {
    return {
        type: SET_LAST_PAGE,
        lastPageIndex
    };
}

export function initPages(pages) {
    return {
        type: INIT_PAGES,
        pages
    };
}

export function initNavigationPages(navPages) {
    return {
        type: INIT_NAVIGATION_PAGES,
        navPages
    };
}

export function pagesReducer(state = initialState.get('pages'), action = null) {
    const { pages, currentPageIndex, navPages } = action;
    switch (action.type) {
        case INIT_PAGES:
            return state.set('pageList', fromJS(pages));
        case INIT_NAVIGATION_PAGES:
            return state.set('navigationPageList', fromJS(navPages));
        case SET_ACTIVE_PAGE:
            const pageList = state.get('pageList');
            const lastPageIndex = state.get('lastPageIndex');
            if (lastPageIndex < pageList.size) {
                if (currentPageIndex > lastPageIndex) {
                    return state.set('currentPageIndex', currentPageIndex).set('lastPageIndex', currentPageIndex);
                }
                return state.set('currentPageIndex', currentPageIndex);
            }
            return state;
        case SET_LAST_PAGE:
            return state.set('lastPageIndex', action.lastPageIndex);
        default:
            return state;
    }
}

export const APP_RESET_STATE = 'app/RESET_STATE';
export const PEDIGREE_GENERATED = 'app/PEDIGREE_GENERATED';
export const SERVER_SAVED = 'app/SERVER_SAVED';
export const SERVER_ERROR_ON_SAVE = 'app/SERVER_ERROR_ON_SAVE';
export const SERVER_ERROR_ON_COMPLETE = 'app/SERVER_ERROR_ON_COMPLETE';


export default function AppReducer(state = initialState, action = null) {
    const defaultState = {
        fields: fieldsReducer(state.fields, action),
        pages: pagesReducer(state.pages, action),
        pedigreeGenerated: state.pedigreeGenerated || initialState.get('pedigreeGenerated'),
        components: componentsReducer(state.components, action),
        width: state.width || initialState.get('width'),
        height: state.height || initialState.get('height'),
        token: state.token || initialState.get('token'),
        language: state.language || initialState.get('language'),
        headerLink: state.headerLink || initialState.get('headerLink'),
        dataLoaded: state.dataLoaded || initialState.get('dataLoaded'),
        errorText: state.errorText || initialState.get('errorText')
    };
    const updatedState = createReducerSwitch(defaultState)
    .on(PEDIGREE_GENERATED, () => { defaultState.pedigreeGenerated = true; return defaultState; })
    .on(APP_RESET_STATE, () => initialState)
    .on(APP_INIT_DATA_RECEIVE, () => { defaultState.dataLoaded = true; return defaultState; })
    .on(FCH_ACTIONS_LIST, FCHReducer)
    .on(SERVER_SAVED, () => {
        defaultState.errorText = null;
        return defaultState;
    })
    .on(SERVER_ERROR_ON_SAVE, () => {
        defaultState.errorText = [
            'Oops!...',
            'An error occurred.',
            'Please check your internet connection and reload the page.'
        ].join(' ');
        return defaultState;
    })
    //.on(SERVER_ERROR_ON_COMPLETE, not implemented as for now)
    .reduce(action);
    return updatedState;
}
